import React from "react";

import {
  LegalDomainTask1,
  LegalDomainTask2,
  LegalDomainTask3,
  LegalDomainTask4,
  LegalDomainTask5,
  LegalDomainTask6,
  LegalDomainTask7,
  LegalDomainTask8,
  LegalDomainTask9,
  LegalDomainTaskPlaceholder
} from "./LegalDomainTasks";

interface LegalDomainTaskFactoryProps {
  slideKey: string;
  setHeader: (header: string) => void;
  questionCompleter: any;
}

const LegalDomainTaskFactory: React.FC<LegalDomainTaskFactoryProps> = (
  props
) => {
  const { slideKey, setHeader, questionCompleter } = props;

  const getCurrentSlide = () => {
    switch (slideKey) {
      case "LegalDomainTask1":
        return LegalDomainTask1;
      case "LegalDomainTask2":
        return LegalDomainTask2;
      case "LegalDomainTask3":
        return LegalDomainTask3;
      case "LegalDomainTask4":
        return LegalDomainTask4;
      case "LegalDomainTask5":
        return LegalDomainTask5;
      case "LegalDomainTask6":
        return LegalDomainTask6;
      case "LegalDomainTask7":
        return LegalDomainTask7;
      case "LegalDomainTask8":
        return LegalDomainTask8;
      case "LegalDomainTask9":
        return LegalDomainTask9;
      default:
        return LegalDomainTaskPlaceholder;
    }
  };

  const currentSlide = getCurrentSlide()!(questionCompleter);

  setHeader(currentSlide.header);

  return <>{currentSlide.content}</>;
};

export default LegalDomainTaskFactory;
